<template>
  <nav class="navbar" ref="myNavbar">
    <app-message/>
    <div class="logo">
      <router-link to="/">
        <img src="../img/logo.png" alt="логотип">
      </router-link>
    </div>
    <div class="popup">
      <button class="popupButton" @click="modal = true; scrollLock()">Связаться с нами</button>
      <router-link to="/auth"><button class="navButton">Личный кабинет</button></router-link>
    </div>
    <transition name="slideBurger">
    <app-modal
            v-if="modal"
            @close="modal = false; scrollLock()">
    </app-modal>
    </transition>
    <div class="burgerMenu" :class = "{active: burger === true}" @click.prevent.stop="toggleBurger()">
      <span></span>
    </div>
    <transition name="slideBurger">
    <app-burger
        v-if="burger"
    ></app-burger>
    </transition>
  </nav>
</template>

<script>

import {computed, onMounted, ref} from 'vue';
import AppModal from "@/components/AppModal";
import AppBurger from "@/components/AppBurger";
import store from '@/store';
import AppMessage from "@/components/ui/AppMessage";
import {useRouter} from 'vue-router'
import {useStore} from 'vuex'


export default {
  components: {
    AppModal,
    AppBurger,
    AppMessage
  },
  setup() {
    const router = useRouter()
    const store = useStore()

    let myNavbar = ref(null);
    let width = ref(null);

    const getWidth = () => {
      if (!myNavbar.value) {
        return;
      }
      width.value = myNavbar.value.clientWidth;
    }

    onMounted( () => {
      getWidth();

      new ResizeObserver(getWidth).observe(myNavbar.value);
    });

    let modal = ref(false)

    const burger = computed(() => {
      return store.state.burger
    })

    function scrollLock() {
      if (modal.value === true) {
        document.body.style.overflow = "hidden"
      } else {
        document.body.style.overflow = ""
      }
    }
    function toggleBurger() {
      store.commit('toggleBurger')
    }

    return {
      modal,
      burger,
      scrollLock,
      toggleBurger,
      myNavbar,
      width,
      getWidth,

      logout: () => {
        store.commit('auth/logout')
        router.push('/auth')
      }
    }
  }
}
</script>

<style scoped>

.slideBurger-enter-from {
  opacity: 0;
}
.slideBurger-leave-to {
  opacity: 0;
}
.slideBurger-enter-active, .slideBurger-leave-active {
  transition: all 1s;
}

img {
  width: 143px;
  height: 88px;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  height: 88px;
  background-color: #24305e;
}

.logo {
  height: 88px;
}

.popupButton {
  background-color: #24305e;
  cursor: pointer;
}

.navButton {
  background: #24305e;
  border: none;
  font-weight: 600;
  color: white;
  padding: 10px;
  font-size: 1em;
  cursor: pointer;
  margin-right: 15px;
  margin-left: 50px;
}

.navButton:hover {
  color: #ffd700;
}

a.active button {
  color: #ffd700;
  border-bottom: 5px solid #ffd700;
}

@media (min-width: 1200px) {
  .navButton {
    font-size: 0.7em;
  }
}
@media (min-width: 1700px) {
  .navButton {
    font-size: 1.0em;
  }
}

.popupButton {
  font-weight: 800;
  position: relative;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  padding: 10px 30px;
  margin: 0 15px;
  color: #ffd700;
  font-size: 20px;
  transition: 0.5s;
}

.popupButton:hover {
  background: #ffd700;
  color: #111;
  box-shadow: 0 0 50px #ffd700;
  transition-delay: 0.5s;
}

.popupButton:before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  width: 15px;
  height: 15px;
  border-top: 4px solid #ffd700;
  border-left: 4px solid #ffd700;
  transition: 0.5s;
}

.popupButton:hover:before {
  width: 100%;
  height: 100%;
}

.popupButton:after {
  content: "";
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 15px;
  height: 15px;
  border-bottom: 4px solid #ffd700;
  border-right: 4px solid #ffd700;
  transition: 0.5s;
}

.popupButton:hover:after {
  width: 100%;
  height: 100%;
}

.burgerMenu {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background-color: orange;
  height: 88px;
  width: 88px;
}

.burgerMenu span {
  display: block;
  position: absolute;
  top: 41px;
  left: 14px;
  right: 14px;
  height: 8px;
  background: white;
  transition-delay: 0.3s, 0s;

}

.burgerMenu span:before, .burgerMenu span:after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  height: 8px;
  background: white;
  transition-duration: 0.3s, 0.3s;
  transition-delay: 0.3s, 0s;
}

.burgerMenu span:before {
  top: -20px;
  transition-property: top, transform;
}

.burgerMenu span:after {
  bottom: -20px;
  transition-property: bottom, transform;
}

.burgerMenu.active span {
  background: none;
}

.burgerMenu.active span:before {
  top: 0;
  transform: rotate(-45deg)
}

.burgerMenu.active span:after {
  bottom: 0;
  transform: rotate(45deg)
}

.burgerMenu.active span:before, .burgerMenu.active span:after {
  transition-delay: 0s, 0.3s;
}

@media (max-width: 1200px) {
  .popupButton {
    font-size: 20px;
  }
  .navButton {
    font-size: 20px;
  }
}

@media (max-width: 900px) {
  .burgerMenu span {
    top: 30px;
  }

  .burgerMenu span:before {
    top: -15px;
  }

  .burgerMenu span:after {
    bottom: -15px;
  }

  img {
    width: 100px;
    height: 66px;
  }

  .navbar {
    height: 66px;
  }

  .popupButton {
    display: none;
  }

  .logo {
    height: 66px;
  }

  .burgerMenu {
    height: 66px;
    width: 66px;
  }

  .navButton {
    font-size: 18px;
    margin: 0;
  }
}

@media (max-height: 600px) {
  .popupButton {
    height: 66px;
    font-size: 16px;
  }
}

</style>